import { useState } from 'react';

import {
  Button, PageHeader, Tag, Typography, Image,
} from 'antd';
import { PlusCircleOutlined, BarChartOutlined, BarcodeOutlined } from '@ant-design/icons';
import { Content } from 'antd/lib/layout/layout';
import { getProductList } from 'configs';
import { observer } from 'mobx-react';
import { Box } from 'components/Box';
import store from 'store/mainStore';
import { Link } from 'react-router-dom';
import TableBox from 'components/TableBox/TableBox';

import ProductModal from './ProductModal';

const Products = () => {
  const { curr, dictionaries, setUpdateSubscribe } = store;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [product, setProduct] = useState<any>({});

  const toogleModal = (state: boolean, prod: any = {}) => {
    setProduct(prod);
    setIsOpen(state);
    if (!state) {
      setUpdateSubscribe('Список товаров');
      setProduct(null);
    }
  };

  const getColor = (state: string) => {
    const int = Number(state);
    switch (int) {
      case 1:
        return 'processing';
      case 2:
        return 'warning';
      case 6:
        return 'success';
      default:
        return 'error';
    }
  };

  const COLUMN: any = [
    {
      title: '',
      dataIndex: 'pic',
      fixed: 'left',
      width: 70,
      minWidth: 70,
      key: '1',
      ellipsis: true,
      render: (row: any) => (
        <Image
          width={50}
          height={50}
          src={JSON.parse(row)[0]}
          // eslint-disable-next-line max-len
          fallback="data:image/png;base64,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"
        />
      ),
    },
    {
      title: 'Название товара',
      dataIndex: 'name',
      fixed: 'left',
      width: 250,
      minWidth: 250,
      key: '2',
      ellipsis: true,
      render: (row: any, record: any) => (<Typography.Link onClick={() => toogleModal(true, record)}>{`(${record.product_id}) ${row}`}</Typography.Link>),
    },
    {
      title: '',
      width: 30,
      minWidth: 0,
      dataIndex: 'product_id',
      key: '3',
      render: (row: any) => (<Link to={`/dashboard/product/${row}`} target="_blank"><BarChartOutlined /></Link>),
    },
    {
      title: 'Статус',
      dataIndex: 'state_name',
      width: 90,
      minWidth: 90,
      ellipsis: true,
      key: '4',
      render: (row: any, rows: any) => (
        <Tag color={getColor(rows.state)}>
          {row}
        </Tag>
      ),
    },
    {
      title: 'Заполненность',
      dataIndex: 'not_full',
      ellipsis: true,
      width: 50,
      key: '4',
      render: (row: any) => (
        <Tag color={row !== '1' ? 'success' : 'error'}>
          {row !== '1' ? 'Да' : 'Нет'}
        </Tag>
      ),
    },
    {
      title: 'Раздел',
      dataIndex: 'category_name',
      ellipsis: true,
      width: 150,
      key: '5',
    },
    /*  {
      title: 'Производство (дней)',
      dataIndex: 'produce_days',
      key: '6',
      width: 100,
      minWidth: 100,
    }, */
    /* {
      title: 'Вес единицы кг.',
      dataIndex: 'weight',
      width: 100,
      key: '8',
      minWidth: 100,
      render: (row: any) => (row / 1000),
    }, */
    {
      title: 'Цена',
      dataIndex: 'price',
      key: '9',
      width: 120,
      minWidth: 120,
      render: (row: any, all: any) => (<Typography.Text>{`${row} ${all.curr}`}</Typography.Text>),
    },
    {
      title: 'Цена ~(руб)',
      dataIndex: 'price',
      key: '10',
      width: 100,
      minWidth: 100,
      render: (row: any, all: any) => (<Typography.Text>{(all.curr !== 'RUB' ? row * curr.cny : Number(row)).toFixed(2)}</Typography.Text>),
    },
    {
      title: 'Продано',
      dataIndex: 'count_sell',
      key: '11',
      width: 100,
      minWidth: 100,
      render: (row: any) => (<Typography.Text strong type={row < 1 ? 'danger' : 'success'}>{row || 0}</Typography.Text>),
    },
    {
      title: 'В наличии',
      dataIndex: 'in_store',
      key: '12',
      width: 100,
      minWidth: 100,
      render: (row: any) => (<Typography.Text strong type={row < 1 ? 'danger' : 'success'}>{row || 0}</Typography.Text>),
    },
    {
      title: 'В резерве',
      dataIndex: 'reserve',
      key: '12',
      width: 100,
      minWidth: 100,
      render: (row: any) => (<Typography.Text strong type="secondary">{row || 0}</Typography.Text>),
    },
  ];

  const prod_category = (dictionaries?.prod_category || []).map((el: any) => ({
    label: el.name,
    value: el.id,
    search: el.name,
  })) || [];

  const prod_status = (dictionaries?.product_status || []).map((el: any) => ({
    label: el.name,
    value: el.id,
    search: el.name,
  })) || [];

  const notFullOptions = [
    {
      label: 'Заполнен',
      value: '0',
    },
    {
      label: 'Не заполнен',
      value: '1',
    },
  ];

  const filters = [
    {
      name: 'name',
      type: 'input',
      label: 'Название',
      placeholder: 'Выедите название товара',
    },
    {
      name: 'category',
      type: 'select',
      label: 'Категорию',
      placeholder: 'Выберите категорию',
      options: prod_category,
    },
    {
      name: 'state',
      type: 'select',
      label: 'Статус',
      placeholder: 'Выберите статус',
      options: prod_status,
    },
    {
      name: 'not_full',
      type: 'select',
      label: 'Полный товар',
      placeholder: 'Выберите заполненность',
      options: notFullOptions,
    },
  ];

  return (
    <>
      <PageHeader
        title={(
          <Box direction="row" style={{ gridGap: 10 }} align="center">
            Товары
            <BarcodeOutlined />
          </Box>
)}
      />
      <ProductModal isOpen={isOpen} toogle={toogleModal} product={product} />
      <Content>
        <TableBox
          title="Список товаров"
          filters={filters}
          extra={<Button type="primary" onClick={() => setIsOpen(true)} icon={<PlusCircleOutlined />}>Добавить товар </Button>}
          column={COLUMN}
          scroll={1500}
          config={getProductList}
        />

      </Content>
    </>
  );
};
export default observer(Products);
